module.exports = __webpack_public_path__ + "images/emoji/ok.5385ee6fca220c3a3446.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/ok.png
// module id = pNFf
// module chunks = 24